import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUserStore } from '../../stores/userStore';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import './DocumentAdminAccess.css';
export function useDocumentManagement() {
  const admin = useUserStore((s) => s.isAdmin);
  const { search } = useLocation();
  return admin && new URLSearchParams(search).get('manage') === '1';
}
export function DocumentAdminLink({ editing = false, disabled = false }) {
  const admin = useUserStore((s) => s.isAdmin);
  const { pathname, search } = useLocation();
  const { locale } = useWebLocale();
  if (!admin) return null;
  const params = new URLSearchParams(search);
  if (editing) params.delete('manage');
  else params.set('manage', '1');
  const query = params.toString();
  const label = editing
    ? locale === 'en'
      ? 'Back to reader'
      : '읽기 화면으로'
    : locale === 'en'
      ? 'Edit guide · Admin'
      : '안내 편집 · 관리자';
  return (
    <div className="pp-document-admin-link">
      <Link
        to={pathname + (query ? '?' + query : '')}
        aria-disabled={disabled || undefined}
        onClick={(event) => {
          if (disabled) event.preventDefault();
        }}
      >
        {label}
      </Link>
    </div>
  );
}
